import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'DroneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 10h4v4h-4z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 10l-3.5 -3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 10l3.5 -3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 14l3.5 3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 14l-3.5 3.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
    }, null), _createTextVNode(" ")]);
  }
};